// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__3Mcul","fee":"Footer_fee__1gChI","time":"Footer_time__FgcH8"};